import { Beef } from "lucide-react";

/**
 * CSS-rendered luxury pack — displayed like premium perfume.
 * Matches the reference packaging: ivory pouch, serif brand, colour-coded band.
 */
export const ProductPack = ({ product, size = "md" }) => {
    const isLimited = product.limited_edition;
    const scale = {
        sm: { pack: "w-36", brand: "text-[9px]", cut: "text-lg", icon: 22 },
        md: { pack: "w-48 sm:w-52", brand: "text-[10px]", cut: "text-2xl", icon: 30 },
        lg: { pack: "w-64 sm:w-72", brand: "text-xs", cut: "text-4xl", icon: 44 },
    }[size];

    return (
        <div
            className={`${scale.pack} mx-auto select-none`}
            data-testid={`product-pack-${product.slug}`}
        >
            <div
                className="relative rounded-[10px] overflow-hidden border border-black/10"
                style={{
                    background: "linear-gradient(175deg, #FAF6ED 0%, #EFE8D9 100%)",
                    boxShadow:
                        "0 18px 40px rgba(11,11,12,0.18), inset 0 1px 0 rgba(255,255,255,0.7)",
                    aspectRatio: "3 / 4.2",
                }}
            >
                {/* hang notch */}
                <div className="absolute top-2 left-1/2 -translate-x-1/2 w-8 h-[5px] rounded-full bg-black/10" />

                <div className="flex flex-col items-center h-full pt-6 pb-0 px-3">
                    {/* Union Jack mark */}
                    <svg width="18" height="11" viewBox="0 0 18 11" className="mb-1.5 opacity-80" aria-hidden="true">
                        <rect width="18" height="11" fill="#0E1A2B" />
                        <path d="M0 0 L18 11 M18 0 L0 11" stroke="#F6F1E7" strokeWidth="2.2" />
                        <path d="M9 0 V11 M0 5.5 H18" stroke="#F6F1E7" strokeWidth="3.4" />
                        <path d="M9 0 V11 M0 5.5 H18" stroke="#7A1F2B" strokeWidth="1.8" />
                    </svg>

                    <div
                        className={`font-serif-display ${scale.brand} tracking-[0.32em] text-center leading-tight`}
                        style={{ color: "#141416", fontWeight: 600 }}
                    >
                        BRITISH
                        <br />
                        STEAK CO.
                    </div>
                    <div className="font-mono-meta text-[6.5px] tracking-[0.3em] mt-1 text-black/50">
                        DRY AGED BEEF
                    </div>

                    <div className="flex-1 flex flex-col items-center justify-center gap-2">
                        <Beef size={scale.icon} strokeWidth={1.2} style={{ color: product.band_color }} />
                        <div
                            className={`font-serif-display ${scale.cut} tracking-[0.14em] uppercase text-center`}
                            style={{ color: "#141416", fontWeight: 600 }}
                        >
                            {product.name.replace("British ", "").replace("The ", "")}
                        </div>
                        {isLimited && (
                            <div className="font-mono-meta text-[7px] tracking-[0.26em] text-black/60 border border-black/20 px-2 py-0.5">
                                LIMITED RELEASE
                            </div>
                        )}
                    </div>

                    {/* colour band */}
                    <div
                        className="w-full py-2.5 px-2 -mx-3 text-center"
                        style={{ backgroundColor: product.band_color, width: "calc(100% + 24px)" }}
                    >
                        <div className="font-mono-meta text-[7px] tracking-[0.22em] text-[#F6F1E7]/90">
                            {product.ingredients.length} INGREDIENTS · {product.weight_g}g
                        </div>
                        <div className="font-mono-meta text-[6.5px] tracking-[0.18em] text-[#F6F1E7]/60 mt-0.5">
                            {product.ingredients.join(" + ").toUpperCase()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
